import { useMemo } from 'react'

import { useTranslation } from 'react-i18next'
import { Step } from 'react-joyride'

import { useGuideTooltip } from 'shared/hooks/use-guide-tooltip'
import { JoyrideTour } from 'shared/ui/joyride-tour'

const COOKIE_KEY = 'tour_search_params_edit_hint'

export const SearchEditGuide = () => {
  const { t } = useTranslation()
  const content = t('tours_block.search_result_guide.edit_header_hint')
  const steps = useMemo<Step[]>(
    () => [
      {
        target: '#share',
        content,
        placement: 'bottom-end',
        disableBeacon: true,
        disableScrolling: true,
        spotlightPadding: 0,
      },
    ],
    [content],
  )

  const { run, locale, handleCallback } = useGuideTooltip({
    steps,
    cookieKey: COOKIE_KEY,
    localeKeys: {
      last: 'tours_block.search_result_guide.last',
    },
  })

  return (
    <JoyrideTour
      steps={steps}
      run={run}
      onCallback={handleCallback}
      locale={locale}
    />
  )
}
